// f:\checkin\frontend\src\components\ui\FormSpinnerOverlay.jsx
import React from 'react';

const FormSpinnerOverlay = ({ isLoading }) => {
    if (!isLoading) {
        return null;
    }

    return (
        <div style={{
            position: 'absolute',
            top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.75)', // Slightly increased opacity for better visibility
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 1000 // Ensure it's on top
        }}>
            <div className="spinner-border text-success" role="status" style={{ width: '3rem', height: '3rem' }}>
                <span className="visually-hidden">Cargando...</span>
            </div>
        </div>
    );
};

export default FormSpinnerOverlay;